import React, { useEffect, useRef } from "react";

import Layout from "../components/layouts/Layout";
import { useState } from "react";
import { GetTicketList } from "../services/TicketService";
import { Pagination } from "@nextui-org/pagination";
import useTicketStore from "../stores/useTicketStore";
import AppUserProfile, { UserType } from "../assets/js/AppUserProfile";
import DealerTicketTile from "../components/ticketDetail/DealerTicketTile";
import ApproverTicketTile from "../components/ticketDetail/ApproverTicketTile";
import useApproverStore from "../stores/useApproverStore";
import FilterBar from "../components/layouts/filters/FilterBar";
import { useQueryParams } from "../hooks/useQueryParams";

const HistoryTicketListPage = () => {
  const [tickets, setTickets] = useState({ tickets: [], pagination: {} });
  const userRole = AppUserProfile.getData()["whoami"];
  const initializationComplete = useRef(false);

  const { approvers, fetchApprovers } = useApproverStore();
  const queryParams = useQueryParams();

  const {
    pagination,
    setPagination,
    handlePageChange,
    initFilterByRole,
    getFilterParams,
    activeFilters,
    formatOtherFilter,
    findTicketId,
  } = useTicketStore();

  const handlePageChangeClick = (page) => {
    handlePageChange(page, queryParams);
  };

  const loadTicket = async () => {
    try {
      const baseParams = getFilterParams();

      const filterParams = {
        ...baseParams,
        statuses: ["CANCELLED"],
      };

      const data = await GetTicketList({ bodyPayload: filterParams });
      if (data.status != 200) return;

      const sortedTickets = [...data.data.tickets].map((ticket) => ({
        ...ticket,
        sub_tickets: [...ticket.sub_tickets].sort((a, b) => a.id - b.id),
      }));

      setTickets({ tickets: sortedTickets, pagination: data.data.pagination });
      setPagination(data.data.pagination);
    } catch (e) {
      void e;
    }
  };

  useEffect(() => {
    if (!approvers || approvers.size === 0) {
      fetchApprovers();
    }
  }, [approvers]);

  useEffect(() => {
    if (!userRole) return;

    const initialize = async () => {
      initFilterByRole(userRole, queryParams);

      setTimeout(() => {
        initializationComplete.current = true;

        loadTicket();
      }, 100);
    };

    initialize();
  }, [userRole]);

  useEffect(() => {
    if (initializationComplete.current) {
      loadTicket();
    }
  }, [activeFilters, formatOtherFilter, findTicketId, pagination.page_id]);

  return (
    <>
      <Layout>
        <div className="py-5">
          <FilterBar isDisableStatus={true} />
        </div>
        {tickets.tickets.length ? (
          <>
            <div className="flex flex-col gap-y-6 px-8">
              {tickets.tickets.map((ticket) => {
                return (
                  <div key={ticket.id + ticket.status} className="">
                    {userRole === UserType.DEALER_BYD ||
                    userRole === UserType.DEALER_DENZA ? (
                      <DealerTicketTile
                        ticketData={ticket}
                        reFetch={loadTicket}
                      />
                    ) : (
                      <ApproverTicketTile ticketData={ticket} />
                    )}
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <div className="flex items-center justify-center min-h-screen">
            ไม่พบคำขอ
          </div>
        )}
        {tickets.tickets.length ? (
          <div className="flex justify-center py-5">
            <Pagination
              initialPage={1}
              page={pagination.page_id}
              total={pagination.last_page}
              classNames={{
                item: "w-8 h-8 text-small rounded-xl bg-transparent border-transparent",
                cursor: "bg-black text-white font-bold",
              }}
              onChange={handlePageChangeClick}
            />
          </div>
        ) : (
          <></>
        )}
      </Layout>
    </>
  );
};

export default HistoryTicketListPage;
